var map = {
	"./chevron-down.svg": 116,
	"./chevron-up.svg": 138,
	"./computer.svg": 823,
	"./currency.svg": 40,
	"./documents.svg": 550,
	"./precisely.svg": 983,
	"./remove.svg": 127,
	"./users.svg": 840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 107;